










































import Vue, { PropType } from "vue";
import { NotificationsCorporateResponse } from "@/api/dto/Notification";

export default Vue.extend({
  name: 'CorporateTopNotifications',
  props: {
    current: String,
    notifList: Array as PropType<NotificationsCorporateResponse[]>,
  },
  computed: {
  },
  data() {
    return {
      accordionToggleFlag: true,
    }
  },
  methods: {
    accordionToggle() {
      this.accordionToggleFlag = this.accordionToggleFlag == true ? false : true;
    },
    getUpdated(notification: any): string {
      let posted = new Date(notification.date);
      // 差分 = 現在の日時 - 投稿日時 
      let diff = new Date().getTime() - posted.getTime();

      // 経過時間をDateに変換
      let progress = new Date(diff);
      let text = '';

      if (progress.getUTCFullYear() - 1970) {
        text = progress.getUTCFullYear() - 1970 + '年前';
      } else if (progress.getUTCMonth()) {
        text = progress.getUTCMonth() + 'ヶ月前';
      } else if (progress.getUTCDate() - 1) {
        text = progress.getUTCDate() - 1 + '日前';
      } else if (progress.getUTCHours()) {
        text = progress.getUTCHours() + '時間前';
      } else if (progress.getUTCMinutes()) {
        text = progress.getUTCMinutes() + '分前';
      } else {
        text = 'たった今';
      }
      return text;
    },
  }
})
